package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class AdminMessageSenderRole {
    @SerialName("buyer") BUYER,
    @SerialName("seller") SELLER,
    @SerialName("system") SYSTEM,
}

@Serializable
data class AdminConversationMessage(
    val id: String,
    @SerialName("sender_id") val senderId: String? = null,
    @SerialName("sender_name") val senderName: String? = null,
    @SerialName("sender_role") val senderRole: AdminMessageSenderRole,
    val type: String,
    val body: String? = null,
    @SerialName("image_url") val imageUrl: String? = null,
    @SerialName("is_deleted") val isDeleted: Boolean = false,
    @SerialName("created_at") val createdAt: String,
)

@Serializable
data class AdminMessagesResponse(
    val messages: List<AdminConversationMessage>,
)
